import { useField } from "formik";
import { FC, useEffect, useState } from "react";
import { Col, Loader, Row } from "taltech-styleguide";
import { application } from "../../../../../_runtime/bootstrap";
import { HttpResponse } from "@dirootie-core/http-types";
import {
  InputDescription,
  InputName,
  InputSelect,
} from "@components-common/forms";
import { ProgressWizardStepForm } from "../../wizard/ProgressWizardStepForm";
import { mapDataToDropdownOptions } from "../../wizard/helpers";
import { useParams } from "react-router-dom";
import { useWizard } from "../../wizard/context";
import associateBuildTeacherSchema from "./associate-build-teacher.schema";

export const AssignBuildToAssignments = ({ ...props }) => {
  const { title, element } = props;
  const { state } = useWizard();
  const { id, assignmentId } = useParams();

  return (
    <ProgressWizardStepForm
      title={title}
      element={element.configInformation}
      schema={associateBuildTeacherSchema}
    >
      {!state.isInCourseAssignment && <MainContent />}
      <BuildingConfigInfo
        isInCourseAssignment={state.isInCourseAssignment}
        courseId={id!}
        assignmentId={assignmentId!}
      />
    </ProgressWizardStepForm>
  );
};

const MainContent = () => {
  const [fieldCourse, helpersCourse, metaCourse] = useField(`courseId`);
  const [fieldAssignment, helpersAssignment, metaAssignment] =
    useField(`assignmentId`);
  const [isLoading, setIsLoading] = useState(true);
  const [coursesList, setCoursesList] = useState<any>([]);
  const [assignmentList, setAssignmentList] = useState<any[]>([]);

  useEffect(() => {
    application
      .getHttpClient()
      .get(`coursesms/courses`)
      .then((x: HttpResponse) => {
        setCoursesList(mapDataToDropdownOptions(x.body.items, "id", "name"));
        setTimeout(() => {
          if (x.body.items.length > 0) {
            metaCourse.setValue(x.body.items[0].id);
          }
          setIsLoading(false);
        }, 1000);
      });
  }, []);

  useEffect(() => {
    if (fieldCourse.value !== "") {
      setIsLoading(true);
      application
        .getHttpClient()
        .get(`coursesms/assignments?courseId=${fieldCourse.value}`)
        .then((x: HttpResponse) => {
          setAssignmentList(
            mapDataToDropdownOptions(x.body.items, "id", "title")
          );
          setTimeout(() => {
            if (x.body.items.length > 0) {
              metaAssignment.setValue(x.body.items[0].id);
            }
            setIsLoading(false);
          }, 1000);
        });
    }
  }, [fieldCourse.value]);
  return isLoading ? (
    <Loader overlay></Loader>
  ) : (
    <Row>
      <Col sm="12" md="6">
        <InputSelect
          id="courseId"
          label="Course"
          elementClass="required"
          options={coursesList}
        />
        {coursesList.length === 0 && (
          <p>There are no courses created. Create one first please.</p>
        )}
        {fieldCourse.value !== "" && (
          <>
            <InputSelect
              id="assignmentId"
              label="Assignment"
              elementClass="required"
              options={assignmentList}
            />
            {assignmentList.length === 0 && (
              <p>There are no courses created. Create one first please.</p>
            )}
          </>
        )}

        <p className="pt-3">
          Before submitting your building configuration make sure you have the
          correct assignment selected
        </p>
      </Col>
    </Row>
  );
};

export type Props = {
  isInCourseAssignment: boolean;
  courseId: string;
  assignmentId: string;
};

export const BuildingConfigInfo: FC<Props> = ({
  isInCourseAssignment,
  courseId,
  assignmentId,
}) => {
  const [fieldCourse, helpersCourse, metaCourse] = useField(`courseId`);
  const [fieldAssignment, helpersAssignment, metaAssignment] =
    useField(`assignmentId`);

  useEffect(() => {
    if (isInCourseAssignment) {
      metaAssignment.setValue(assignmentId);
      metaCourse.setValue(courseId);
    }
  }, []);

  return (
    <div className="mb-3">
      <InputName elementClass="required" />
      <InputDescription />
    </div>
  );
};
